import React from 'react'

const TableSortUpIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="m3 8 4-4 4 4"></path>
            <path d="M7 4v16"></path>
            <path d="M11 12h4"></path>
            <path d="M11 16h7"></path>
            <path d="M11 20h10"></path>
        </svg>
    )
}

export default TableSortUpIcon
